import React from 'react';
import {useQuery} from "@tanstack/react-query";
import userService from "../../../../services/web/user-service.js";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import Loader from "../../../../components/template/loader.jsx";
import TimePeriodInput from "../../../../components/reports/time-period-input/time-period-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const optionsTypes = {
  nature: "Natureza",
  observation: "Observação do atendente",
  finalobservation: "Observação final",
  factplace: "Local pré-cadastrado",
  factstreet: "Logradouro",
  factnumber: "Número",
  factneighborhood: "Bairro",
  sectors: "Setor",
  factlatitude: "Latitude/Longitude",
}

const optionsArr = Object.entries(optionsTypes).map(([key, value]) => ({value: key, label: value}));
const Filters = ({ setFilters, filters }) => {
  const handleSpecialInput = useGeneralInputSpecialCase(setFilters);

  const {data: attendants = [], isLoading: isLoadingAttendants} = useQuery({
    queryFn: userService.attendantsIdentifications,
    queryKey: ['attendants']
  })

  return (
    <>
      {isLoadingAttendants && <Loader/>}
      <div className={`mb-2 ${minMenuHeight}`}>
        <form id="search-form" className="flex flex-col gap-6">
          <InputDateTime
            id="dtStart"
            label="Data inicial *"
            selected={filters.dtStart ? new Date(filters.dtStart) : null}
            onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
            classNameWrapper={"w-full"}
            dateFormat="L"
          />
          <div>
            <InputDateTime
              id="dtEnd"
              label="Data final *"
              selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
              onChange={date => {
                handleSpecialInput('dtEnd', date)
              }}
              dateFormat="L"
            />
          </div>
          <TimePeriodInput filters={filters} setFilters={setFilters} singleRow={true}/>
          <div>
            <SelectComponent
              id="options"
              instanceId="options"
              label="Indicadores de Preenchimento *"
              options={optionsArr}
              onChange={selected => handleSpecialInput("options", selected)}
              isMulti
              value={optionsArr.filter(el => filters.options.map(el => el.value).includes(el.value))}
            />
          </div>
          <div>
            <SelectComponent
              id="attendants"
              instanceId="attendants"
              label="Atendentes"
              options={attendants}
              value={attendants.filter(el => filters.attendant.includes(el.value))}
              onChange={selected => handleSpecialInput("attendant", selected.map(attendant => attendant.value))}
              isMulti
            />
          </div>
          <div>
            <InputCheckbox
              id="attendanceList"
              label="Listar atendimento"
              checked={filters.attendantList}
              onChange={() => setFilters(prev => ({...prev, attendantList: !prev.attendantList}))}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default Filters;